/* Aviso del inicio: Solicitudes a SST que SST le devolvió al usuario para
 * corregir (estado DEVUELTA).
 *
 * - No pinta nada si no tiene ninguna devuelta (o si falla la consulta).
 * - Solo consulta si el usuario puede solicitar a SST (permiso de EMSYS,
 *   cacheado por sesión): así los operarios no suman una request por cada
 *   entrada al inicio.
 * - Cada fila abre el detalle, donde está el comentario de SST y el formulario
 *   para corregir y reenviar; la tarjeta abre Mis solicitudes.
 */
import { Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { fmtFecha } from "src/components/SolicitudCapacitacionCampos";
import { cargarPermisoSst, SolicitudSstAPI, SolicitudSstResumen } from "src/services/sst";

const MAX_FILAS = 3;
const VIOLETA = "#8e44ad";

const SolicitudesSstDevueltasCard: React.FC = () => {
  const history = useHistory();
  const [items, setItems] = useState<SolicitudSstResumen[]>([]);

  // Las rutas van en un <Switch>: el inicio se vuelve a montar al regresar
  // (por ejemplo, después de reenviar una corregida), así que alcanza con useEffect.
  useEffect(() => {
    let vigente = true;
    cargarPermisoSst()
      .then((puede) => (puede === false ? null : SolicitudSstAPI.mis()))
      .then((r) => {
        if (vigente && r) setItems((r.data.data || []).filter((s) => s.estado === "DEVUELTA"));
      })
      .catch(() => vigente && setItems([]));
    return () => {
      vigente = false;
    };
  }, []);

  if (!items.length) return null;

  return (
    <div className="container mt-1">
      <div
        onClick={() => history.push("/sst/solicitudes?tab=mis")}
        style={{
          cursor: "pointer",
          background: "#fff",
          borderRadius: 10,
          borderLeft: `6px solid ${VIOLETA}`,
          boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
          padding: "12px 14px",
          marginBottom: 10,
        }}
      >
        <Typography variant="caption" style={{ color: VIOLETA, fontWeight: 700 }}>
          ↩️ SOLICITUDES A SST · DEVUELTAS
        </Typography>
        <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
          {items.length === 1
            ? "SST te devolvió 1 solicitud para corregir"
            : `SST te devolvió ${items.length} solicitudes para corregir`}
        </Typography>

        {items.slice(0, MAX_FILAS).map((s) => (
          <div
            key={s.id}
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/sst/solicitudes/${s.id}`);
            }}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 8,
              fontSize: 13,
              padding: "6px 0",
              borderTop: "1px solid #eee",
            }}
          >
            <span style={{ flex: 1 }}>
              N° {s.id} · {s.tipo_label}
            </span>
            <span style={{ whiteSpace: "nowrap", color: VIOLETA, fontWeight: 600 }}>
              {s.gestionado_en ? fmtFecha(s.gestionado_en) : "Corregir"}
            </span>
          </div>
        ))}

        <Typography variant="caption" style={{ color: VIOLETA, fontWeight: 600 }}>
          {items.length > MAX_FILAS ? `Ver las ${items.length} →` : "Tocá para ver el comentario y corregirla →"}
        </Typography>
      </div>
    </div>
  );
};

export default SolicitudesSstDevueltasCard;
